/**
 * 7TV
 *
 * Twitch/YouTube emote extension; resources scoped to those platforms.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 3.1.23.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ammjkodgmmoknidbanneddgankgfejfh';
export const sevenTv: ExtensionDefinition = {
  id: ID,
  name: "7TV",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  requiredOrigin: 'https://www.twitch.tv',
  notes: "Twitch/YouTube emote extension; resources scoped to those platforms.",
  signals: [
    { id: 'war-site-js', kind: 'web-accessible-resource',
      description: 'Fetch site.js, exposed only to https://www.twitch.tv.',
      weight: 1, run: () => probeFetch(ID, 'site.js') },
    { id: 'war-worker-js', kind: 'web-accessible-resource',
      description: 'Fetch worker.js, exposed only to https://www.twitch.tv.',
      weight: 0.5, run: () => probeFetch(ID, 'worker.js') },
  ],
};
